// src/hooks/useMediaQuery.ts
// SSR-safe matchMedia subscription via useSyncExternalStore (client-only app).
import { useSyncExternalStore } from 'react';
import { query } from '@/theme/breakpoints';

export function useMediaQuery(q: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(q);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => window.matchMedia(q).matches,
    () => false, // server snapshot (never hit in this client-only app)
  );
}

export type Viewport = 'mobile' | 'tablet' | 'desktop';

/** Derive the active tier (spec §1). Desktop wins, then tablet, else mobile. */
export function useViewport(): Viewport {
  const isDesktop = useMediaQuery(query.desktop);
  const isTabletUp = useMediaQuery(query.tabletUp);
  return isDesktop ? 'desktop' : isTabletUp ? 'tablet' : 'mobile';
}
